import React from 'react';

const ShortenedFormUploadInstructions = ()=> {
  return (
    <div>
      <div>
        Upload Signed Application & last 3 months of complete Bank Statements
      </div>
    </div>
  );
};

export default ShortenedFormUploadInstructions;
